/* eslint-disable no-magic-numbers */
/* global L */

import 'expose-loader?L!leaflet';
import 'leaflet.markercluster';

L.FaceMarker = L.Marker.extend({
  setFaceProperties(face) {
    this.face = face;

    return this;
  },
});

L.faceMarker = function (latlng, options) {
  return new L.FaceMarker(latlng, options);
};

export default {
  template: '<div></div>',
  props: ['map', 'faces', 'show'],
  mounted() {
    this.topFaces = L.markerClusterGroup({
      maxClusterRadius: 150,
      showCoverageOnHover: false,
      iconCreateFunction: (cluster) => {
        const faces = cluster.getAllChildMarkers()
          .map(faceMarker => faceMarker.face)
          .sort((a, b) => b.size - a.size)
          .slice(0, 4);

        return this._getFaceIcon(faces);
      },
    });
  },
  methods: {
    _getFaceIcon(faces) {
      let iconHTML = '';
      if (faces.length >= 4) {
        iconHTML = faces.map(face => `
          <img src="${face.purchasePhoto.smallUrl}"
            class="top-face__face top-face__face--small"
            style="background-color: ${face.purchasePhoto.dominantColor}"
          ">`)
          .join('');
      } else {
        iconHTML = `
          <img src="${faces[0].purchasePhoto.smallUrl}"
            class="top-face__face"
            style="background-color: ${faces[0].purchasePhoto.dominantColor}"
          ">`;
      }

      return L.divIcon({
        className: 'top-face',
        html: iconHTML,
        iconSize: 100,
      });
    },
    refreshFaceMarkers() {
      if (this.topFaces) this.topFaces.clearLayers();
      if (this.show) {
        const faceMarkers = this.faces.map(face => {
          const faceBounds = L.latLngBounds(face.bounds);
          const faceIcon = this._getFaceIcon([face]);

          return L.faceMarker(faceBounds.getCenter(), { icon: faceIcon })
            .setFaceProperties(face);
        });

        this.topFaces.addLayers(faceMarkers);
        this.topFaces.on('click clusterclick', (e) => {
          this.map.fireEvent('click', e);
        });
        this.topFaces.on('click', (e) => {
          this.map.flyTo(e.latlng, this.map.getMaxZoom());
        });
      }
    },
  },
  watch: {
    show() {
      this.refreshFaceMarkers();
    },
    faces() {
      this.refreshFaceMarkers();
    },
    map() {
      this.topFaces.addTo(this.map);
    },
  },
};
